/**
 * Route constants shared across guards and auth screens.
 *
 * Why: the post-login landing page used to be hard-coded as a string in five
 * places. One constant means moving the landing page again is a one-line change.
 */
export const HOME_ROUTE = '/app/home';
